export default __webpack_public_path__ + "static/media/Background_00170.35332990.png";